module.exports = __webpack_public_path__ + "static/4_2_recommendation_SL-5c28bdad12c49eadbe7acbc4eae8ad2a.svg";